import { Component } from '@angular/core'

@Component({
  selector: 'kdgh-form-section',
  templateUrl: './form-section.component.html',
  styleUrls: ['./form-section.component.scss'],
})
export class FormSectionComponent {}
